export default {
  mounted(el) {
    el.addEventListener('input', (event) => {
      const regexOnlyNumber = /\D/g //regex verify only number
      const value = event.target.value;
      event.target.value = value.replace(regexOnlyNumber, '');
    });
  },
};